export enum Feature {
  PRICEFINDING = "PRICEFINDING",
  DAILYCOUNTING = "DAILYCOUNTING",
  INTRASHOP_IN = "INTRASHOP IN",
  INTRASHOP_OUT = "INTRASHOP OUT",
  ONESTEP = "ONESTEP",
  STGLOCMOVEMENT = "STGLOCMOVEMENT",
  MTO_OCTO = "MTO_OCTO",
  RIBBON = "RIBBON",
  SPECIALORDER = "SPECIALORDER",
}
